// extracted by mini-css-extract-plugin
export var productImage = "_lo-1";
export var viewLink = "_lo-2";
export var wishlistItem = "_lo-0";